import {Component, Input, OnInit} from '@angular/core';
import {EmployeeService} from '../../../../../employee.service';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {SasisopaService} from '../../../../../services/sasisopa.service';
import * as moment from 'moment';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {NewEmployeeComponent} from '../../../../../new-employee/new-employee.component';

@Component({
  selector: 'ngx-emergency-planning-form',
  templateUrl: './emergency-planning-form.component.html',
  styleUrls: ['./emergency-planning-form.component.scss'],
})
export class EmergencyPlanningFormComponent implements OnInit {
  @Input() stationId: string;
  @Input() action: string;
  @Input() infoEdit: any;
  loading = false;
  employees = [];
  data: any = {
    anthropogenic_risks: [
      {
        'name': 'Fugas',
        'value': false,
      },
      {
        'name': 'Derrame de combustible',
        'value': false,
      },
      {
        'name': 'Incendio',
        'value': false,
      },
      {
        'name': 'Explosión de instalaciones',
        'value': false,
      },
      {
        'name': 'Choque de vehículos',
        'value': false,
      },
      {
        'name': 'Asaltos',
        'value': false,
      },
      {
        'name': 'Incendio de vehículos o transporte público',
        'value': false,
      },
      {
        'name': 'Explosión del conversor',
        'value': false,
      },
    ],
    natural_risks: [
      {
        'name': 'Sismos',
        'value': false,
      },
      {
        'name': 'Sequía',
        'value': false,
      },
      {
        'name': 'Tormentas eléctricas',
        'value': false,
      },
      {
        'name': 'Granizo',
        'value': false,
      },
      {
        'name': 'Bajas temperaturas',
        'value': false,
      },
      {
        'name': 'Susceptiblidad de laderas',
        'value': false,
      },
      {
        'name': 'Emergencias de salud',
        'value': false,
      },
      {
        'name': 'Inundación',
        'value': false,
      },
      {
        'name': 'Ciclones tropicales o huracanes',
        'value': false,
      },
      {
        'name': 'Nevadas',
        'value': false,
      },
      {
        'name': 'Ondas de calor',
        'value': false,
      },
    ],
    identified_risk: '',
    before: '',
    current: '',
    after: '',
    financial_resources: '',
    human_resources: '',
    tech_resources: '',
    equipment_resources: '',
    infrastructure_resources: '',
  };

  constructor(
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    private sasisopaService: SasisopaService,
    protected ref: NbDialogRef<EmergencyPlanningFormComponent>,
  ) {
  }

  async ngOnInit() {
    this.loading = true;
    if (this.action === 'edit') {
      this.stationId = this.infoEdit.station_id;
    }
    await this.checkIfCreateOrEdit();
    this.loading = false;
  }

  handleSubmit() {
    if (this.action === 'edit') {
      this.editJobProfile();
    } else {
      this.store();
    }
  }

  async store() {
    this.data.station_id = this.stationId;
    this.loading = true;
    const [error] = await this.sasisopaService.createEmergencyPlanning(this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Formato creado con éxito', 'success');
    this.ref.close(true);
  }

  async editJobProfile() {
    this.loading = true;
    const [error] = await this.sasisopaService.editEmergencyPlanning(this.infoEdit.id, this.data);
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    this.loading = false;
    await this.alert('Formato editado con éxito', 'success');
    this.ref.close(true);
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  async getEmployees() {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }

  async checkIfCreateOrEdit() {
    if (this.action === 'edit') {
      this.data.date = moment(this.infoEdit.date).toDate();
      this.data.station_id = this.infoEdit.station_id;
      this.data.name = this.infoEdit.name;
      this.data.area = this.infoEdit.area;
      this.data.boss = this.infoEdit.boss;
      this.data.level_studies = this.infoEdit.level_studies;
      this.data.other = this.infoEdit.other;
      this.data.experience = this.infoEdit.experience;
      this.data.environment_aspects = this.infoEdit.environment_aspects;
      this.data.activities = this.infoEdit.activities;
      this.data.risks = this.infoEdit.risks;
      this.data.legal_requirements = this.infoEdit.legal_requirements;
      this.data.functions = this.infoEdit.functions;
      this.data.responsibilities = this.infoEdit.responsibilities;
      this.data.authority = this.infoEdit.authority;
      this.data.competencies = this.infoEdit.competencies;
      this.data.age = this.infoEdit.age;
      this.data.schedule = this.infoEdit.schedule;
      this.data.work_days = this.infoEdit.work_days;
      this.data.gender = this.infoEdit.gender;
      this.data.elaborated_by = this.infoEdit.elaborated_by;
      this.data.approval_by = this.infoEdit.approval_by;
    }
  }
}
